import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/template/redux/actions';
import * as pluginActions from '../../../features/plugin/redux/actions';
import SmsTemplateForm from './SmsTemplateForm';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { SMS_TEMPLATE } from 'drapcode-constant';
import * as commonActions from '../../../features/common/redux/actions';

export class SmsTemplate extends Component {
  state = { activeTab: SMS_TEMPLATE };
  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    name: '',
    subject: '',
    collectionId: '',
    selectedCollectionFields: [],
  };

  handleSubmit = (values) => {
    const { projectId, version } = this.props.match.params;
    values.projectId = projectId;
    let args = {
      projectId: projectId,
      version,
      values: values,
    };
    this.props.actions.createSmsTemplate(args).then(() => {
      this.toggle(SMS_TEMPLATE);
    });
  };

  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/2.0/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };

  componentDidMount = () => {
    const { match, actions, pluginActions, location } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetail({ projectId, version });
    actions.loadCollections({ projectId, version });
    if (typeof location.state !== 'undefined' && location.state.activeTab) {
      this.setState({ activeTab: location.state.activeTab });
    }
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  render() {
    const { match, template, plugin, projectDetail, actions } = this.props;
    const { projectId, version } = match.params;
    const { collections, createSmsTemplatePending } = template;
    const { installedPlugins } = plugin;
    const { activeTab } = this.state;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={SMS_TEMPLATE}
              title={'SMS Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="tab-content">
                  <div
                    className={`tab-pane ${activeTab === SMS_TEMPLATE && 'active'}`}
                    id="emailTemplate"
                  >
                    <div className="row mx-auto">
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                        <div className="card">
                          <div
                            className="card-header card-header-icon"
                            data-background-color="drapcode-dark-blue"
                          >
                            <i className={`wb ${drapcodeIcon(SMS_TEMPLATE)}`}></i>
                          </div>
                          <div className="card-content">
                            <SmsTemplateForm
                              handleSubmit={this.handleSubmit}
                              collections={collections}
                              createSmsTemplatePending={createSmsTemplatePending}
                              projectDetail={projectDetail}
                              projectId={projectId}
                              actions={actions}
                              version={version}
                            />
                          </div>
                        </div>
                      </div>

                      <ParentDocCard>
                        <h5>
                          <b>SMS Template</b>
                        </h5>
                        <p>You can create custom SMS templates and send them to different users.</p>
                      </ParentDocCard>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
    projectDetail: state.common.projectDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SmsTemplate);
